// FIRST: wraps axios.create so every store's client sends the device id
import './api/deviceHeader'

import './assets/main.css'

import { createApp } from 'vue'
import { vCan } from '@/directives/can'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
// @ts-ignore
// import myPlugin from './plugins/myPlugin.js'


import dayjs from 'dayjs'

import Oruga from '@oruga-ui/oruga-next'
import '@oruga-ui/oruga-next/dist/oruga.css'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import {
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUser,

} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { bulmaConfig } from '@oruga-ui/theme-bulma'
import '@oruga-ui/theme-bulma/dist/bulma.css'

import './assets/main.css'
import './assets/material.css'
import './assets/oruga-material.css'
import '@/assets/mdi/css/materialdesignicons.min.css'

import '@/assets/material.css'
import '@/assets/oruga-material.css'

// LAST, deliberately: it reclaims vertical space in forms by overriding the
// vendor sheets' margins, and relies on cascade order rather than !important.
import './assets/form-density.css'

// To implement mdi icons in your component:
// Use o-icon syntax from https://oruga.io/components/Icon.html#examples
// Change pack to "mdi" and icon to any of the icon names in https://pictogrammers.github.io/@mdi/font/6.5.95/
// For example, you will see "F1960 mdi-account-lock-open" from mdi icon names. Just use "account-lock-open"
// <o-icon pack="mdi" icon="account-lock-open" size="large"> </o-icon> large small medium normal

library.add(
  fas,
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUser
)

// dom.watch();

const pinia = createPinia()

const app = createApp(App)
app.directive('can', vCan)
  .use(pinia)
  .use(router)
  // .use(myPlugin)
  .component('vue-fontawesome', FontAwesomeIcon)
  .use(Oruga, {
    ...bulmaConfig,
    iconPack: 'mdi',
    iconPrefix: 'mdi-',
    iconSize: 'large',

    // iconComponent: 'vue-fontawesome',
    iconComponenet: undefined,
    statusIcon: true,
    button: {
      rootClass: 'btn',
      outlinedClass: 'btn-outline-',
      disabledClass: 'btn-disabled',
      variantClass: (variant: any, context: any) => {
        // Apply variant when the element is not outline
        if (!context.props.outlined) {
          return `btn-${variant}`
        }
      }
    },
    field: {
      labelClass: 'form-label',
      messageClass: 'form-text',
      variantClass: 'field-',
      rootClass: 'field'
    },
    input: {
      inputClass: 'form-control',
      variantClass: (variant: any) => {
        switch (variant) {
          case 'danger':
            return 'is-invalid'
        }
      }
    },
    dropdown: {
      rootClass: 'dropdown',
      //menuClass: 'dropdown-menu show',
      itemClass: 'dropdown-item',
      itemActiveClass: 'active'
    },
    steps: {
      itemHeaderActiveClass: 'steps-nav-item-active',
      itemHeaderPreviousClass: 'steps-nav-item-previous',
      stepMarkerClass: 'step-marker',
      stepDividerClass: 'step-divider'
    },
    checkbox: {
      checkClass: 'form-check',
      checkCheckedClass: 'form-check-checked',
      labelClass: 'form-check-label'
    }
  })
// .mixin({
//   methods: {
//     sayHello: (msg: string) => 'Hello ' + msg,
//     formatMoney: (amount: number) => {
//       const formatter = new Intl.NumberFormat('en-IN', {
//         // style: "currency",
//         // currency: 'PHP',

//         // These options are needed to round to whole numbers if that's what you want.
//         //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//         //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       })
//       return amount === undefined ? amount : formatter.format(amount)
//     },
//     formatDateTime: (datetime: Date): string => {
//       return dayjs(datetime).format('MM/DD/YYYY HH:mm:ss')
//     },
//     formatDate: (datetime: Date): string => {
//       return dayjs(datetime).format('MM/DD/YYYY')
//     },

//     formatTime: (datetime: Date): string => {
//       return dayjs(datetime).format('hh:mmA')
//     },
//     formatDuration: (datetime: Date): string => {
//       return dayjs(datetime).format('HH:mm')
//     },

//     logHours: (logs: string) => {
//       if (logs.includes('undefined')) {
////         return [0,0,0]
//       }

//       const lg = logs.trim().split(',').filter(item=>item !='').sort()


//       // clean up logs diff less than 5 minutes
//       const res = 15
//       const max = lg.length

//       let lx = [...lg].sort()

//       for (let i = 0; i <= max; i++) {
//         for (let j = 0; j <= max; j++) {
//           if (j > i) {
//             const m = dayjs(lg[j]).diff(dayjs(lg[i]), 'minutes')
//             if (Math.abs(m) < res) {
//               lx = lx.filter(item=>item != lg[j])
//             }
//           }
//         }

//       }
//       lx = lx.map(item=>dayjs(item).format('YYYY-MM-DD HH:mm:ss')).sort()
//
//       if (lx.length%2>0) {
//         return 0
//       }
//       // calculate diffs
//       const diffs = []
//       for (let i = 0; i < lx.length / 2; i++) {
//         const m = dayjs(lx[i * 2 + 1]).diff(dayjs(lx[i * 2]), 'minutes') / 60
//         /* */
//         diffs.push(m)
//       }
////       const totalHours = diffs.reduce((tot, curr) => (tot += curr), 0)
//
//       const dayHours = 9
//       const hoursBreak = 1

//       const formatter = new Intl.NumberFormat('en-IN', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       })

//       const HW = formatter.format(totalHours - hoursBreak)
//       const UT = formatter.format((totalHours - hoursBreak) < dayHours ?dayHours - (totalHours - hoursBreak) : 0 )
//       const OT = formatter.format((totalHours - hoursBreak)  > dayHours ? (totalHours - hoursBreak) - dayHours : 0)
//       return [HW, UT, OT]
//     },

//     sanitizeLogs: (logs: string): string => {
//       if (logs.includes('undefined')) {
//         return ''
//       }

//       const lg = logs.trim().split(',').filter(item=>item !='')

//
//       // clean up logs diff less than 5 minutes
//       const res =15
//       const max = lg.length

//       let lx = [...lg].sort()

//       for (let i = 0; i <= max; i++) {
//         for (let j = 0; j <= max; j++) {
//           if (j > i) {
//             const m = dayjs(lg[j]).diff(dayjs(lg[i]), 'minutes')
//             if (Math.abs(m) < res) {
//               lx = lx.filter(item=>item != lg[j])
//             }
//           }
//         }

//       }
//

//       return lx.map(item=>dayjs(item).format('YYYY-MM-DD HH:mm:ss')).sort().join(", ")
//     }
//   }
// })

app.mount('#app')
